import { Link, TableCell, TableRow, Typography } from "@mui/material"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { JIRA_BROWSE_URL, toPercent } from "plugins/toolbox/constants"

export function CheckExistingRow({ item }) {
    const similarity = toPercent(item.similarity)
    const bestLineScore = toPercent(item.bestLine?.score)

    return (
        <TableRow hover>
            <TableCell>
                <Link href={`${JIRA_BROWSE_URL}/${item.key}`} target="_blank" rel="noopener noreferrer">
                    {item.key}
                </Link>
            </TableCell>
            <TableCell>
                <TruncatedTypography variant="body2">{item.summary}</TruncatedTypography>
            </TableCell>
            <TableCell align="right">{similarity}</TableCell>
            <TableCell>
                <TruncatedTypography variant="body2">{item.bestLine?.sentence}</TruncatedTypography>
                <Typography variant="caption" color="text.secondary">
                    {bestLineScore}
                </Typography>
            </TableCell>
        </TableRow>
    )
}
